import clsx from 'clsx'

const Paper = ({ children, className, ...props }) => {
  return (
    <div
      className={clsx('px-2 py-8 my-7', className, {
        'bg-white shadow-full-xs rounded-3xl': !className
      })}
      {...props}
    >
      {children}
    </div>
  )
}

export default Paper
